import api from '@/utils/api';

/**
 * get category api
 *
 * @param {string} categoryId The category id
 * @returns {Promise} The promise object of the api call
 */
const getCategoryApi = (categoryId) => api.get(`category/${categoryId}`);
export default getCategoryApi;
